var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankOfferBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#234B9E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H17V17H7V16ZM8 12H9V15.5H8V12ZM10.5 12H11.5V15.5H10.5V12ZM12.5 12H13.5V15.5H12.5V12ZM15 12H16V15.5H15V12ZM7 9.5L12 7L17 9.5V11.5H7V9.5ZM12 10C12.2762 10 12.5 9.77614 12.5 9.5C12.5 9.22386 12.2762 9 12 9C11.7239 9 11.5 9.22386 11.5 9.5C11.5 9.77614 11.7239 10 12 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankOfferBlue);
export default __webpack_public_path__ + "static/media/bank-offer-blue.5f30dca981f23bc21eff07a77adba680.svg";
export { ForwardRef as ReactComponent };